import { render, staticRenderFns } from "./addDraw.vue?vue&type=template&id=20b68da4&scoped=true&"
import script from "./addDraw.vue?vue&type=script&lang=js&"
export * from "./addDraw.vue?vue&type=script&lang=js&"
import style0 from "./addDraw.vue?vue&type=style&index=0&id=20b68da4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b68da4",
  null
  
)

export default component.exports